import React from 'react';

import styles from './ReviewsFeed.module.css';

type TProps = {
  children: React.ReactNode;
};

export const ReviewsFeedWrapper = ({ children }: TProps) => (
  <div className={styles.ReviewsFeed__Wrapper}>{children}</div>
);
